import * as React from 'react';
import styled from 'styled-components';
import ControlButton from 'components/ControlButton';
import {IconTrash} from 'icons';

export interface TodoContainerProps {
  onDelete?(): void;
}

const Container = styled.div`
  padding: 20px;
  box-sizing: border-box;
  background: ${({theme}) => theme.variables.backgroundColor};
  border-radius: 5px;
  
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const Header = styled.div`
  align-items: center;
  justify-content: flex-end;
  grid-auto-flow: column;
  display: grid;
`;

const Controls = styled.div`
  display: inline-grid;
`;

/**
 * This component wraps the todo section.
 * @param {TodoContainerProps} props
 * @return {React.ReactElement<React.PropsWithChildren<TodoContainerProps>>}
 * @constructor
 */
export default function TodoContainer(
    props: React.PropsWithChildren<TodoContainerProps>,
): React.ReactElement<React.PropsWithChildren<TodoContainerProps>> {
  /**
   * Render controls part.
   * @return {JSX.Element}
   */
  function renderControls(): JSX.Element {
    /**
     * Render delete control.
     * @return {JSX.Element}
     */
    function renderDelete(): JSX.Element {
      /**
       * This click event handler.
       */
      function handleClick(): void {
        props.onDelete && props.onDelete();
      }

      return (
        <ControlButton type="button" onClick={handleClick}>
          <IconTrash />
        </ControlButton>
      );
    }
    return (
      <Controls>
        {renderDelete()}
      </Controls>
    );
  }
  return (
    <Container>
      <Header>
        {renderControls()}
      </Header>
      {props.children}
    </Container>
  );
}
